export default {
  aGGridActionMenu: false,
  selectedRowData: {},
  gridData: [],
  gridDataLoading: false,
};
